// extracted by mini-css-extract-plugin
export default {"failMsg":"FailMsg_failMsg__p58Mu","sucessMsg":"FailMsg_sucessMsg__MphA+"};